import ResponsiveImage from '@monofront/design-system/components/ResponsiveImage';
import { mapPrivateLabelCTA } from './mapPrivateLabelCTA';
import { IPrivateLabelCTA } from './types';
import { RichText } from 'prismic-reactjs';
import withSlice from '@screens/SlicesContainer/withSlice';

const PrivateLabelCTA: React.FC<IPrivateLabelCTA> = ({
  caption,
  img,
  items,
  title,
}) => {
  return (
    <>
      <div>
        <RichText render={title} />
        <div className="content">
          <figure>
            <ResponsiveImage
              src={img.url}
              alt={img.alt}
              width={900}
              height={460}
              objectFit="contain"
            />
            <figcaption>
              <RichText render={caption} />
            </figcaption>
          </figure>
          <div className="text">
            <ul>
              {items.map((content, index) => (
                <li key={index}>
                  <span className="num">{index + 1}</span>
                  <RichText render={content.point} />
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <style jsx>{`
        .content {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          grid-gap: var(--space-5);
          margin-top: var(--space-4);
        }

        figure > :global(img) {
          border-radius: var(--rd-4);
        }

        figcaption {
          margin-top: var(--space-3);
        }

        .text {
          background-color: var(--clr-primary-5);
          border-radius: var(--rd-4);
          padding: var(--space-6);
        }

        ul {
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          height: 100%;
        }

        li {
          display: flex;
          align-items: center;
          position: relative;
        }

        li > span {
          margin-right: var(--space-3);
        }

        .num {
          height: 60px;
          min-width: 60px;
          border-radius: var(--rd-4);
          background-color: var(--white);
          padding: var(--space-5);
          display: flex;
          justify-content: center;
          align-items: center;
          color: var(--black);
          font-size: var(--font-size-3);
          font-weight: var(--font-weight-bold);
          font-family: var(--font-family-1);
        }

        @media (max-width: 800px) {
          ul > li:not(:last-child) {
            margin-bottom: var(--space-3);
          }

          .text {
            padding: var(--space-4);
          }
        }
      `}</style>
    </>
  );
};

export default withSlice(PrivateLabelCTA, mapPrivateLabelCTA);
